export enum SyncState {
  open   = 'open',
  synced = 'synced',
  closed = 'closed',
}
